export default "__VITE_ASSET__CeO_zdwd__"